<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Sales VAT Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      filterSales: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: "",
        branch_id: 0,
        type: "",
        page: 1,
        per_page: 50,
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Sales VAT Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Sales VAT Report",
          active: true,
        },
      ],

      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsSalesReportDataServerPaginated: true,
      filter: null,
      sortDesc: false,
      modal_id: "",
    };
  },
  computed: {
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("saledetails", [
      "filterStatus",
      "SalesReportData",
      "SalesReportDataPagination",
      "SalesReportDataSummary",
      "SalesReportDataPaginated",
    ]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["business", "branch", "Branches", "branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "SPrice_no",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_priceno",
          sortable: true,
          label: "TOTAL PRICE",
        },
        {
          key: "tax",
          sortable: true,
          label: "VAT",
        },
        {
          key: "net",
          sortable: true,
          label: "NET",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "FDN",
          sortable: true,
          label: "FDN",
        },
        {
          key: "receipt",
          sortable: true,
          label: "RECEIPT",
        },
      ];

      if (this.branchid == 0) {
        baseFields.splice(9, 0, {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        });
      }

      if (
        this.GeneralSettings &&
        this.GeneralSettings.allow_multiple_productcodes
      ) {
        baseFields.splice(2, 0, {
          key: "product_code",
          sortable: true,
          label: "PRODUCT CODE(S)",
        });
      }
      return baseFields;
    },

    rows() {
      return this.IsSalesReportDataServerPaginated
        ? this.SalesReportDataPagination.total
        : this.SalesReportData
        ? this.SalesReportData.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsSalesReportDataServerPaginated) {
          return (
            this.SalesReportDataPagination.per_page ||
            this.filterSales.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsSalesReportDataServerPaginated) {
          this.filterSales.per_page = value;
          this.filterSales.page = 1;
          this.FetchSalesReportData(this.filterSales);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.SalesReportDataPaginated && this.SalesReportDataPagination
          ? this.SalesReportDataPagination.current_page
          : 1;
      },
      set(value) {
        if (this.SalesReportDataPaginated) {
          this.filterSales.page = value;
          this.handlePageChange(value);
        }
      },
    },

    total_amount() {
      return (
        this.SalesReportDataSummary || {
          totalAmount: 0,
          totalCost: 0,
          totalDiscount: 0,
          totalTax: 0,
          totalNet: 0,
        }
      );
    },
  },
  
  methods: {
    ...mapActions({
      FetchSalesReportData: "saledetails/fetchSalesReportData",
      FetchProducts: "products/fetchProducts",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",
    }),

    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SalesReportFilter() {
      let payload = { ...this.filterSales };

      payload.page = 1;
      // Keep the current per_page value instead of resetting to serverPerPage
      if (!payload.per_page) {
        payload.per_page = this.serverPerPage;
      }

      this.FetchSalesReportData(payload);
    },

    handlePageChange(newPage) {
      if (this.IsSalesReportDataServerPaginated) {
        this.filterSales.page = newPage;
        this.FetchSalesReportData(this.filterSales);
      }
    },

    Excel_export() {
      axios
        .post("export_sales", this.filterSales, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {});
    },
  },

  created() {
    this.FetchSalesReportData(this.filterSales);
    this.FetchProducts();
    this.FetchGeneralSettings();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">
        {{ business }}
      </h4>
      <h4 v-if="GeneralSettings.show_branchname == 1 && branch">
        <em
          v-if="
            GeneralSettings.show_branchname == 1 &&
            GeneralSettings.show_businessname == 1
          "
          >-</em
        >
        {{ branch }}
      </h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-12">
                <h3 class="card-title mb-2 text-center">
                  Sales VAT Report from {{ filterSales.datefrom }} to
                  {{ filterSales.dateto }}
                </h3>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>

                <model-list-select
                  :list="
                    Branches
                      ? [{ id: 0, name: 'All Branches' }, ...Branches]
                      : []
                  "
                  v-model="filterSales.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="SalesReportFilter()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                  type="date"
                  v-model="filterSales.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                  v-model="filterSales.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                <model-list-select
                  :list="
                    Products
                      ? [{ id: '', name: 'All Products' }, ...Products]
                      : []
                  "
                  v-model="filterSales.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="SalesReportFilter()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="SalesReportFilter()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <div>
                <DataTable
                  :columns="fields"
                  :rows="SalesReportData || []"
                  :total-rows="rows"
                  :pagination="SalesReportDataPagination"
                  :server-pagination="IsSalesReportDataServerPaginated"
                  :loading="filterStatus"
                >
                  <template #cell(index)="{ index }">
                    {{ (currentPage - 1) * perPage + index + 1 }}
                  </template>
                  <template #cell(product)="{ row }">
                    {{ row.product }}
                  </template>

                  <template
                    v-if="GeneralSettings.allow_multiple_productcodes"
                    #cell(product_code)="{ row }"
                    >{{ row.product_code }}</template
                  >
                  <template #cell(qty)="{ row }">{{ row.qty }} {{ row.usymbol }}</template>
                  <template #cell(Sprice_no)="{ row }">{{
                    row.SPrice_no
                  }}</template>
                  <template #cell(total_priceno)="{ row }">{{
                    row.total_priceno
                  }}</template>
                  <template #cell(tax)="{ row }">{{
                    row.tax.toLocaleString()
                  }}</template>
                  <template #cell(net)="{ row }">{{
                    row.net.toLocaleString()
                  }}</template>
                  <template #cell(date)="{ row }">{{
                    row.date
                  }}</template>
                  <template #cell(receipt)="{ row }">{{
                    row.receipt
                  }}</template>
                  <template #cell(branch)="{ row }" v-if="branchid == 0">{{
                    row.branch
                  }}</template>
                </DataTable>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(total_amount.totalAmount)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-4">
                  <h5>
                    Total VAT:
                    <span class="text-danger">{{
                      thousandSeperator(total_amount.totalTax)
                    }}</span>
                  </h5>
                </div>
                <div class="col-md-4">
                  <h5>
                    Total Net:
                    <span class="text-danger">{{
                      thousandSeperator(total_amount.totalNet)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
